// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import addProduct from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/AddProduct";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import ProductSelector, { ProductSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductSelector, { ProductSelectorStyles } from "@steiner/Overrides/Components/ProductSelector";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    addProduct,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

export interface QuickOrderSearchStyles {
    // xng-change: change import
    productSelector?: ProductSelectorStyles;
    // xng-change
    labelWrapper?: InjectableCss;
    label?: TypographyPresentationProps;
    tooltip?: TooltipPresentationProps;
}

export const quickOrderSearchStyles: QuickOrderSearchStyles = {};

const styles = quickOrderSearchStyles;

const QuickOrderSearch = ({ addProduct }: Props) => {
    const toasterContext = useContext(ToasterContext);

    const addProductToOrder = (productInfo: ProductInfo, product: ProductModel) => {
        addProduct({ productInfo, product });
        toasterContext.addToast({ body: translate("Item Added"), messageType: "success" });
    };

    return (
        <ProductSelector
            selectButtonTitle={translate("Add to Order")}
            onSelectProduct={addProductToOrder}
            productIsConfigurableMessage={siteMessage("QuickOrder_CannotOrderConfigurable")}
            productIsUnavailableMessage={siteMessage("QuickOrder_ProductIsUnavailable")}
            extendedStyles={styles.productSelector}
            // xng-change
            overrideLabel={
                <StyledWrapper {...styles.labelWrapper}>
                    <Typography {...styles.label}>{translate("Search For Your Product")}</Typography>
                    <Tooltip {...styles.tooltip} text={siteMessage("QuickOrder_Instructions").toString()} />
                </StyledWrapper>
            }
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(QuickOrderSearch),
    definition: {
        group: "Quick Order",
        allowedContexts: ["QuickOrderPage"],
    },
};

export default widgetModule;
